import { loadStripe } from '@stripe/stripe-js';

const stripePublishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

if (!stripePublishableKey) {
  console.warn('Warning: REACT_APP_STRIPE_PUBLISHABLE_KEY is not set. Payments will not work.');
}

// Initialize Stripe - lazy loaded
let stripePromise = null;

export const getStripe = () => {
  if (!stripePromise && stripePublishableKey) {
    stripePromise = loadStripe(stripePublishableKey);
  }
  return stripePromise;
};

// Pricing configuration matching LandingPage.js
export const pricingPlans = [
  {
    id: 'basic',
    name: 'Basic',
    monthlyPrice: 4.99,
    yearlyPrice: 49.99,
    monthlyPriceId: process.env.REACT_APP_STRIPE_PRICE_BASIC_MONTHLY,
    yearlyPriceId: process.env.REACT_APP_STRIPE_PRICE_BASIC_YEARLY,
    features: [
      '5 Stories per Month',
      '3 Regenerations per Story',
      '5 Saved Characters',
      { text: 'No Audio Reading', negative: true }
    ],
    limits: {
      storiesPerMonth: 5,
      regenerationsPerStory: 3,
      maxCharacters: 5,
      audioEnabled: false
    }
  },
  {
    id: 'premium',
    name: 'Premium',
    monthlyPrice: 9.99,
    yearlyPrice: 99.99,
    monthlyPriceId: process.env.REACT_APP_STRIPE_PRICE_PREMIUM_MONTHLY,
    yearlyPriceId: process.env.REACT_APP_STRIPE_PRICE_PREMIUM_YEARLY,
    features: [
      '30 Stories per Month',
      '10 Regenerations Per Story',
      '10 Saved Characters',
      'Basic Audio Reading'
    ],
    limits: {
      storiesPerMonth: 30,
      regenerationsPerStory: 10,
      maxCharacters: 10,
      audioEnabled: true
    },
    popular: true
  },
  {
    id: 'premium_plus',
    name: 'Premium Plus',
    monthlyPrice: 19.99,
    yearlyPrice: 199.99,
    monthlyPriceId: process.env.REACT_APP_STRIPE_PRICE_PREMIUM_PLUS_MONTHLY,
    yearlyPriceId: process.env.REACT_APP_STRIPE_PRICE_PREMIUM_PLUS_YEARLY,
    features: [
      'Unlimited Story Generations',
      'Unlimited Regenerations Per Story',
      'Unlimited Saved Characters',
      'Enhanced Audio Reading'
    ],
    limits: {
      storiesPerMonth: Infinity,
      regenerationsPerStory: Infinity,
      maxCharacters: Infinity,
      audioEnabled: true,
      enhancedAudio: true
    }
  }
];

// Free tier limits
export const freeTierLimits = {
  storiesPerMonth: 2,
  regenerationsPerStory: 1,
  maxCharacters: 2,
  audioEnabled: false
};

// Get plan by ID
export const getPlanById = (planId) => {
  return pricingPlans.find(plan => plan.id === planId);
};

// Get limits for a tier
export const getLimitsForTier = (tier) => {
  if (!tier || tier === 'free') {
    return freeTierLimits;
  }
  const plan = getPlanById(tier);
  return plan?.limits || freeTierLimits;
};
